import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import HeaderBar from "./HeaderBar";
import { logOut } from "../../redux/authentication/actionCreator";
import { getItem } from "../../utils/localStorageControl";
import { AppDispatch } from "../../redux/store";

const AdminLayout: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();

  const user = getItem("user");

  const handleLogout = () => {
    dispatch(logOut());
  };

  const shouldShowHeader = location.pathname !== "/";

  // Memoize user object to prevent unstable references
  const memoizedUser = React.useMemo(() => {
    return user ? { name: user.name, email: user.email } : undefined;
  }, [user?.name, user?.email]);

  return (
    <div>
      {shouldShowHeader && user && memoizedUser && (
        <HeaderBar
          user={memoizedUser}
          onLogout={handleLogout}
        />
      )}
      <Outlet />
    </div>
  );
};

export default AdminLayout;
